export default __webpack_public_path__ + "static/media/loginImage.ce434a22.svg";